import { SearchProductPrice } from '@epicuro-next/models/products';
import { ProductPriceRanges } from 'graphql-api/gql-api-interfaces';

export function mapProductPrices<
  T extends {
    prices?: SearchProductPrice[];
  },
>(product: T): ProductPriceRanges[] {
  let productPrices: ProductPriceRanges[] = [];
  if (product?.prices) {
    productPrices = product.prices.map((e) => ({
      currency: e.wsp?.currency || e.rrp?.currency,
      rrp: {
        currency: e.rrp?.currency,
        min: e.rrp?.min,
        max: e.rrp?.max,
      },
      wsp: {
        currency: e.wsp?.currency,
        min: e.wsp?.min,
        max: e.wsp?.max,
      },
      wspd: {
        currency: e.wspd?.currency,
        min: e.wspd?.min,
        max: e.wspd?.max,
      },
      validityPeriod: {
        startDate: e.validityPeriod?.startDate,
        endDate: e.validityPeriod?.endDate,
      },
      markup: e.markup?.max,
      discount: {
        max: e.discountPercentage,
        min: e.discountPercentage,
      },
    }));
  }

  return productPrices;
}
